import {numberWithSpaces} from "../../../../../utils/helpers";
import {useTranslation} from "react-i18next";

export const getAdditionalInfo = (extraServices?: ExtraService[]) => {

  const { t } = useTranslation()

  if (!extraServices?.length) {
    return [
      [
        {
          label: t('common__text__additionalServices'),
          value: t('common__text__nonExistent')
        }
      ]
    ]
  }

  const servicesArray = extraServices.flatMap(extraService =>
    (extraService.services ?? []).map(service => ({
      label: service.name,
      value: `${numberWithSpaces(service.price)} ${service.currency}`
    })));

  return [ servicesArray ]
}
